export default {
  nl: {
    faq: {
      title1: 'Veelgestelde',
      title2: 'vragen',
      text: 'Zoek of blader door de meest gestelde vragenover je afspraak met {{partner}}',
      search: 'Zoeken in FAQ',
      thereAreNoFaqAvailable: 'Er zijn geen FAQ beschikbaar',
      loadingFAQ: 'Laden veelgestelde vragen',
      filter: 'Filter',
      noSearchResultsTitle: 'Geen zoekresultaten gevonden.',
      noSearchResultsDescription: 'Probeer een andere zoekterm of\nbekijk alle veelgestelde vragen.',
      noSearchResultsViewAllButton: 'Bekijk alle veelgestelde vragen',
      searchResultCount_zero: 'Geen resultaten',
      searchResultCount_one: '{{count}} zoekresultaat',
      searchResultCount_other: '{{count}} zoekresultaten',
      searchResultCountFound: 'gevonden',
    },
    faqCategories: {
      Algemeen: 'Algemeen',
      Mijn_afspraak: 'Mijn afspraak',
      De_installatie: 'De installatie',
      Het_bezoek: 'Het bezoek',
    },
    faqSearchResults: 'Dit zijn resultaten voor',
  },
  en: {
    faq: {
      title1: 'Frequently asked',
      title2: 'questions',
      text: 'Search or browse through the most frequently asked questions about your appointment with {{partner}}',
      search: 'Search in FAQ',
      thereAreNoFaqAvailable: 'There are no FAQ available',
      loadingFAQ: 'Loading frequently asked questions',
      filter: 'Filter',
      noSearchResultsTitle: 'No search results found.',
      noSearchResultsDescription: 'Try a different search term or\nview all frequently asked questions.',
      noSearchResultsViewAllButton: 'View all frequently asked questions',
      searchResultCount_zero: 'No search results',
      searchResultCount_one: '{{count}} search result',
      searchResultCount_other: '{{count}} search results',
      searchResultCountFound: 'found',
    },
    faqCategories: {
      Algemeen: 'General',
      Mijn_afspraak: 'My appointment',
      De_installatie: 'The installation',
      Het_bezoek: 'The visit',
    },
    faqSearchResults: 'These are results for',
  },
};
